/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FC, ReactNode } from 'react';
import { Heading, Icon, UpsellBanner } from '@zillow/constellation-10';
import { IconYardSignFilled } from '@zillow/constellation-icons';
import { setCypressID } from 'src/utils/setCypressID';
import { CYPRESS_INTEGRATION_TEST_IDS } from 'src/common/constants';

const { WELCOME_BANNER } = CYPRESS_INTEGRATION_TEST_IDS.MORTGAGE_DASHBOARD;

type WelcomeBannerProps = {
    /**
     * Whether to show or hide the welcome banner
     */
    shouldDisplay: boolean;
    /**
     * Callback to persist hiding the banner. Called when the user clicks the close button of the upsell
     */
    onClose: () => void;
    /**
     * Content to render as the heading of the upsell
     */
    children: ReactNode;
};

/**
 * This renders a welcome banner that explains how to use the Home Loans Dashboard to the user, and
 * when closed will persist the user's choice to close the banner to the client local storage to avoid
 * showing the same banner to them again on the same device.
 */
export const WelcomeBanner: FC<WelcomeBannerProps> = ({ shouldDisplay, onClose, children }) => (
    <div role="status">
        {shouldDisplay && (
            <UpsellBanner.Root tone="impact" {...setCypressID(WELCOME_BANNER.BANNER)}>
                <UpsellBanner.Media>
                    <Icon focusable="false" size="md">
                        <IconYardSignFilled />
                    </Icon>
                </UpsellBanner.Media>
                <UpsellBanner.Content>
                    <UpsellBanner.Header>
                        <Heading level={6}>{children}</Heading>
                        &nbsp;This is where you'll find everything you need during the loan process.
                    </UpsellBanner.Header>
                </UpsellBanner.Content>
                <UpsellBanner.CloseButton onClick={onClose} />
            </UpsellBanner.Root>
        )}
    </div>
);
